module.exports = __webpack_public_path__ + "static/media/en-check-remaining-traffic_2.4f9236f4.png";